import React, {useContext} from 'react';
import AutoSuggestField from "@FormElements/AutoSuggestField";
import FormContext from "formContext";
import {injectIntl} from "react-intl";
import {useRegionsList} from "i18nHelper";

function StateAutosuggestField({intl, settings,   ...rest}) {
  const {currentStep, setFormData, formData} = useContext(FormContext);
  const {regions} = useRegionsList(intl.defaultLocale);
  let regionsOptions = [];
  let regionsFiltered = [];
  const selectedCountry = formData[currentStep] && formData[currentStep].country && formData[currentStep].country;

  if (regions && selectedCountry) {
    Object.keys(regions).map((key) => {
      const region = regions[key];

      if (formData && formData[currentStep] && formData[currentStep][settings.name]) {
        const formValue = formData[currentStep][settings.name];
        // Match the selected country.
        if (selectedCountry.toLowerCase() === region.countryName.toLowerCase()) {
          regionsOptions = Object.keys(region.countryRegions).map(key => {
            // Find match in the list of regions.
            const match = region.countryRegions[key].toLowerCase().indexOf(formValue.toLowerCase()) !== -1;
            if (match) {
              regionsFiltered.push(region.countryRegions[key]);
            }

            return region.countryRegions[key];
          });
        }
      }

      return region[key];
    });
  }

  if (regionsFiltered.length > 0) {
    settings.options = regionsFiltered;
  } else {
    settings.options = regionsOptions;
  }

  rest.onChange = e => {
    const {value} = e.target;
    const match = regionsOptions.find(el => el === value);
    let matchedCountryCode = '';
    // Get region short code from regions list for selected country and store in form
    const regionsBySelectedCountry = regions.find(element => element.countryName.toLowerCase() === selectedCountry.toLowerCase());
    if (regionsBySelectedCountry) {
      Object.keys(regionsBySelectedCountry.countryRegions).map(key => {
        let currentRegion = regionsBySelectedCountry.countryRegions[key];
        if (currentRegion.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
          matchedCountryCode = key;
        }
      });
    }
    if (match) {
      setFormData(prev => {
        if (!prev[currentStep][settings.name]) {
          prev[currentStep][settings.name] = '';
          prev[currentStep]['regionCode'] = '';
        }
        prev[currentStep][settings.name] = match;
        prev[currentStep]['regionCode'] = matchedCountryCode;
        return {
          ...prev
        }
      });
    }
    else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        prev[currentStep]['regionCode'] = '';
        return {
          ...prev
        }
      });
    }
  };

  return (
      <AutoSuggestField
          settings={settings}
          {...rest}
      />
  );
}

export default injectIntl(StateAutosuggestField);
